import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isSkuVenue } from 'helpers/ia-logic';
import { selectUserVenues } from 'selectors/general';

export default function useSkuVenues() {
  const venues = useSelector(selectUserVenues);
  return useMemo(() => venues.filter(isSkuVenue), [venues]);
}
